import React, { Component } from 'react';
import { Spin, Popconfirm } from 'antd';
import TableC from '../../basicElement/TableC';
import Filter from './Filter';
import API_URL from '../../../common/url';
import RegisterTime from './RegisterTime';
import UserDetail from '../../user/UserDetail';
import AjaxRequest from '../../../common/AjaxRequest';
import dictCache from '../../../common/dictCache';
import ExportUtil from '../../../common/ExportUtil';
import RemoveProjectGroup from './RemoveProjectGroup';
import UpdateScore from '../../sumTotal/crcQuarterScore/UpdateScore';
import ViewEfficiency from './ViewEfficiency';
import Sider from '../MemberSider';
import Helmet from 'react-helmet';
import Update from './Update'
import '../style.less';
import CheckAttachment from './CheckAttachment';

class CRC extends Component {
    state = {
        loading: false,
        pagination: {
            pageSize: 10,
            current: 1,
        },
        data: [],
        sortParams: {},
        searchParams: {},
    }

    componentDidMount() {
        this.queryInvestigationStageByInvId();
    }


    loadData = () => {
        this.setState({ loading: true });
        const { sortParams, searchParams, pagination } = this.state;
        const { current, pageSize } = pagination;
        const options = {
            url: API_URL.user.queryCRCList,
            data: {
                offset: current,
                limit: pageSize,
                ...sortParams,
                ...searchParams,
            },
            dataType: 'json',
            doneResult: res => {
                const { memberList } = res.data;
                const { data, totalCount } = memberList;
                pagination.total = totalCount;
                this.setState({
                    data,
                    pagination,
                    loading: false,
                });
            },
            errorResult: () => {
                this.setState({ loading: false });
            },
        };
        AjaxRequest.sendRequest(options);
    }

    search = (params = {}) => {
        const { pagination } = this.state;
        pagination.current = 1;
        this.setState({
            pagination,
            searchParams: { ...params },
        }, () => {
            this.loadData();
        });
    }

    export = () => {
        const { searchParams } = this.state;
        ExportUtil.export(searchParams, null, API_URL.user.exportCRCList);
    }

    queryInvestigationStageByInvId = () => {
        const { invId } = sessionStorage;
        dictCache.getDict(`INV_STAGE_${invId}`, cb => {
            AjaxRequest.sendRequest({
                method: 'POST',
                url: API_URL.investigation.queryInvestigationStageByInvId,
                data: { investigationId: invId },
                dataType: 'json',
                doneResult: res => cb(res),
            });
        }, res => {
            this.setState({ invStageList: res.data });
        });
    }

    canEditByInvStatus = (callback) => {
        const { invStageList: data = [] } = this.state;
        const canEdit = !(data || []).some(i => {
            if (i.operation === 'INVESTIGATION_LEVEL_LOWEST') {
                message.error('项目到达“项目终止”阶段，不可调整项目相关数据！');
                return true;
            } else if (i.operation === 'INVESTIGATION_DATA_LOCK') {
                message.error('项目到达“项目关闭”阶段，不可调整项目相关数据！');
                return true;
            } else if(i.operation === 'TERMINATED_BEFORE_CONTRACT'){
                message.error('项目已在服务合同签署前终止，不可调整项目相关数据');
                return true;
            } else if (i.operation === 'BUSINESS_DATA_ARCHIVING') {
                message.error('项目到达“业务数据归档”阶段，不可编辑项目相关数据');
                return true;
            }
            return false;
        });
        if (canEdit) {
            callback();
        }
    }

    getColumns = () => {
        const { userId, curRole, invState } = sessionStorage;
        const isCRC = curRole == 'CRC';
        const isCRCC = curRole == 'CRCC';
        const isPM = curRole == 'PM';
        const isCRCM = curRole == 'CRCM';
        const isBO = curRole == 'BO';
        const isCSAL = curRole == 'CSAL';
        const isPA = curRole == 'PA';
        const isCTA = curRole == 'CTA';
        const isVP = curRole == 'VP';
        const isFIN = curRole == 'FIN';
        const isPML = curRole == 'PML';
        const columnNames = [
            {
                title: '中心编号',
                dataIndex: 'investigationSiteCode',
                key: 'investigationSiteCode',
                width: 85,
                fixed: 'left',
                sorter: true,
            }, {
                title: '中心名称',
                dataIndex: 'investigationSiteName',
                key: 'investigationSiteName',
                width: 175,
                fixed: 'left',
                sorter: true,
            }, {
                title: '工号',
                dataIndex: 'employeeCode',
                key: 'employeeCode',
                fixed: 'left',
                sorter: true,
                width: 80,
                render: (text, record) => {
                    let canLink = false;
                    if (isCRC) {
                        if (record.userId == userId) {
                            canLink = true;
                        }
                    } else if (isCRCC || isCRCM || isPA) {
                        if (record.allowEnter) {
                            canLink = true;
                        }
                    } else {
                        canLink = true; 
                    }
                    return (
                        canLink ?
                            <a onClick={() => this.viewUser(record.userId)}>{record.employeeCode}</a>
                        :
                            text
                    );
                },
            }, {
                title: '姓名',
                dataIndex: 'userCompellation',
                key: 'userCompellation',
                fixed: 'left',
                width: 70,
                sorter: true,
            }, {
                title: '是否在site授权表上正式授权',
                dataIndex: 'isSiteFormalAuthorization',
                key: 'isSiteFormalAuthorization',
                width: 120,
                render: text => text ? text == '1' ? '是' : '否' : '',
            }, {
                title: '授权时间',
                dataIndex: 'authorizationDate',
                key: 'authorizationDate',
                width: 120,
            }, {
                title: '工作类型',
                dataIndex: 'crcRequirementInfoType',
                key: 'crcRequirementInfoType',
                width: 90,
                render: text => {
                    let newText = '';
                    switch (text) {
                        case 'SSU_LEAD':
                            newText = 'SSU主导';
                            break;
                        case 'PRE_START_ASSISTANCE':
                            newText = '启动前协助';
                            break;
                        case 'AFTER_STARTUP_MEMBER':
                            newText = '启动后人员';
                            break;
                        case 'SSU_LEAD_AFTER_STARTUP_MEMBER':
                            newText = 'SSU主导+启动后';
                            break;
                        case 'PRE_AFTER_STARTUP_MEMBER':
                            newText = '启动前+启动后';
                            break;
                        default:
                            break;
                    }
                    return newText
                }
            },{
                title: '工作城市',
                dataIndex: 'workCity',
                key: 'workCity',
                sorter: true,
                width: 90,
            },{
                title: '参与临床试验经验',
                dataIndex: 'workingLife',
                key: 'workingLife',
                width: 80,
            }, {
                title: '手机号码',
                dataIndex: 'userMobile',
                key: 'userMobile',
                sorter: true,
                width: 100,
            }, {
                title: '邮箱',
                dataIndex: 'userEmail',
                key: 'userEmail',
                sorter: true,
                width: 200,
            }, {
                title: '主管姓名',
                dataIndex: 'leaderName',
                key: 'leaderName',
                width: 80,
            }, {
                title: '主管手机号',
                dataIndex: 'leaderMobile',
                key: 'leaderMobile',
                width: 100,
            }, {
                title: '主管邮箱',
                dataIndex: 'leaderEmail',
                key: 'leaderEmail',
                width: 210,
            }, {
                title: '中心上岗时间',
                dataIndex: 'workBeginTime',
                key: 'workBeginTime',
                sorter: true,
                width: 120,
            }, {
                title: '人员状态',
                dataIndex: 'employeeStatus',
                key: 'employeeStatus',
                sorter: true,
                width: 90,
                render: (text, record) => {
                    if (text == 'WORKING') {
                        return '现任';
                    } else if (text == 'WORKED') {
                        return '前任';
                    } else if (text == 'LEFT') {
                        return '离职';
                    }else if(text=="LEAVE"){
                        return '离任';
                    }else if(text=="LAST_TERM"){
                        return '最后任';
                    }else {
                        return '';
                    }
                },
            }, {
                title: '工作阶段',
                dataIndex: 'workDuration',
                key: 'workDuration',
                sorter: true,
                width: 120,
            }
        ];
        if (!isCRC) {
            columnNames.push({
                title: '操作',
                key: 'operation',
                fixed: 'right',
                width: 120,
                render: (text, record) => {
                    const { employeeStatus } = record;
                    let canLink = false;
                    if (isCRCC || isCRCM) {
                        if (record.allowEnter) {
                            canLink = true;
                        }
                    } else {
                        canLink = true;
                    }
                    return (
                        <span>
                            {
                                (isPM && record.employeeStatus === 'WORKING' && (invState == 1 || invState == 2)) && 
                                <span >
                                    <Popconfirm 
                                        className="removePro" 
                                        placement="topRight"
                                        title="是否需要发起人员交接?" 
                                        // onConfirm={this.confirm} 
                                        onConfirm={() => this.canEditByInvStatus(() => this.confirm())}
                                        onCancel={()=>this.cancel(record.memberId)} 
                                        cancelText="否，直接移出项目组" 
                                        okText="是，发起交接" >
                                        <a>移出项目组</a>
                                    </Popconfirm>
                                    <span className="ant-divider" />
                                </span>
                            }
                            <span>
                                {
                                    !canLink ?
                                        <a disabled={true}>查看效率</a>
                                    :
                                        <a onClick={() => this.viewEfficiency(record.userId, record.investigationSiteId)}>查看效率</a>
                                }
                            </span>
                            {
                                ((isBO || isCSAL || isCTA || isPM || isVP || isFIN || isPML) || ((isCRCC || isCRCM) && canLink)) &&
                                <span>
                                    <span className="ant-divider" />
                                    <a onClick={() => this.updateScore(record)}>查看PM季度评分</a>
                                </span>
                            }
                            {
                                (isPM || isPA) &&
                                <span>
                                    { employeeStatus == 'WORKING' && <span className="ant-divider" />}
                                    { employeeStatus == 'WORKING' && <a onClick={() => this.canEditByInvStatus(() => this.update(record))}>修改</a>}
                                    <span className="ant-divider" />
                                    <a onClick={() => this.checkAttachmentRef.show(record)}>查看附件</a>
                                </span>
                            }
                        </span>
                    );
                },
            });
        } else {
            columnNames.push({
                title: '操作',
                key: 'operation',
                fixed: 'right',
                width: 120,
                render: (text, record) => {
                    const { employeeStatus } = record;
                    if (record.userId == userId) {
                        return (
                            <span>
                                <a onClick={() => this.viewEfficiency(record.userId)}>查看效率</a>
                                <span className="ant-divider" />
                                <a onClick={() => this.registerDutyTime(record.investigationSiteId)}>登记上岗时间</a>
                                <span className="ant-divider" />
                                <a onClick={() => this.updateScore(record)}>查看PM季度评分</a>
                                {
                                    (isPM || isPA || isCRC) &&
                                    <span>
                                        { employeeStatus == 'WORKING' && <span className="ant-divider" />}
                                        { employeeStatus == 'WORKING' && <a onClick={() => this.update(record)}>修改</a>}
                                        <span className="ant-divider" />
                                        <a onClick={() => this.checkAttachmentRef.show(record)}>查看附件</a>
                                    </span>
                                }
                            </span>
                        );
                    } else {
                        return null;
                    }
                },
            });
        }
        return columnNames;
    }

    update = (record) => {
        this.UpdateRef.show(record);
    }

    getDataSource = () => {
        const { data } = this.state;
        const dataSource = data.map(item => {
            const { user, memberId, investigationSite, userRoleInvestigationSiteCrcId, authorizationFileList } = item;
            const { employeeCode, userId, userName, mobile, email, workCity, employeeStatus, workBeginTime, allowEnter, workDuration, leader, workingLife} = user;
            const { investigationSiteId, investigationSiteCode, investigationSiteName, isSiteFormalAuthorization, crcRequirementInfoType, authorizationDate } = investigationSite;
            const { userName: leaderName, mobile: leaderMobile, email: leaderEmail } = leader || {};
            return {
                employeeCode,
                userId,
                investigationSiteId,
                investigationSiteCode,
                investigationSiteName,
                userCompellation: userName,
                userMobile: mobile,
                userEmail: email,
                memberId,
                workCity,
                employeeStatus,
                workBeginTime: workBeginTime ? workBeginTime.substr(0, 10) : '',
                allowEnter,
                workDuration,
                leaderName,
                leaderMobile,
                leaderEmail,
                isSiteFormalAuthorization,
                crcRequirementInfoType,
                authorizationDate,
                userRoleInvestigationSiteCrcId,
                authorizationFileList,
                workingLife,
            };
        });
        return dataSource;
    }

    handleTableChange = (params) => {
        this.setState({
            ...params,
        }, () => {
            this.loadData();
        });
    }
    
    viewEfficiency = (id) => {
        this.viewRef.show(id);
    }

    registerDutyTime = siteId => {
        this.registerTimeRef.show(siteId);
    }

    viewUser = userId => {
        this.userDetailRef.show(userId);
    }

    updateScore = (record = {}) => {
        this.UpdateScoreRef.show(record);
    }

    confirm = () => {
        location.href = './#/execute/transfer';
    }

    cancel = (memberId) => {
        this.removeRef.show(memberId);
    }

    render() {
        const { loading, pagination } = this.state;
        const { siteId, curRole } = sessionStorage;
        const isCRC = curRole == "CRC";
        return (
            <div className="content">
                 <Helmet>
                    <meta name="description" />
                    <style type="text/css">{`
                           body .ant-btn-sm{
                           float:right;
                           background: #108ee9;
                           color: white
                           }
                           .ant-popover-buttons{
                               margin-bottom: 24px;
                           }
                        `}
                    </style>
                </Helmet>
                <Sider selectKey='crc' />
                <div className="main">
                    <Filter
                        search={this.search}
                        export={this.export}
                    />
                    <TableC
                        loading={loading}
                        columns={this.getColumns()}
                        data={this.getDataSource()}
                        rowKey='memberId'
                        onChange={this.handleTableChange}
                        pagination={pagination}
                    />
                </div>
                <ViewEfficiency ref={el => this.viewRef = el} />
                <UserDetail ref={el => this.userDetailRef = el} />
                <RemoveProjectGroup ref={el => this.removeRef = el} loadData={this.loadData} memberId/>
                <RegisterTime ref={el => this.registerTimeRef = el} loadData={this.loadData} />
                <UpdateScore isEdit={false} src='member' ref={el => this.UpdateScoreRef = el} />
                <Update ref={el => this.UpdateRef = el} loadData={this.loadData} />
                <CheckAttachment ref={el => this.checkAttachmentRef = el} loadData={this.loadData} />
            </div>
        );
    }
}

export default CRC;



// WEBPACK FOOTER //
// ./src/components/member/crcInfo/index.js